import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

// Connects to data-controller="modal"
export default class extends Controller {
  connect() {
    const signalModal = new bootstrap.Modal(this.element)
    signalModal.show()
  }
}
